import { __extends, __assign, __makeTemplateObject, __spreadArray, __awaiter, __generator } from 'tslib';
import React, { Fragment, useState, useEffect, Component } from 'react';
import { connect } from 'react-redux';
import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import { useMarketplace, useTranslate, T, TolgeeProvider, MarketplaceProvider, tolgeeModule, getLanguageFromRequest, getTolgee } from '@rakutenfrance/tolgee-provider';
import { LinkOrSpan, LinkOrSpanContext, HideInWebviewHoc, HideInWebview, Hyperlink } from '@rakutenfrance/mui';
import { configService, publicRuntimeConfig } from '@rakutenfrance/config-service';
import { useBreakpoint, BreakpointProvider } from '@rakutenfrance/breakpoint';

var t = {"text":"_f-text-40a21c","helper_hide-AboveTablet":"_f-helper_hide-AboveTablet-c1f097","sr-only":"_f-sr-only-ffa00e","contain":"_f-contain-c56313","db":"_f-db-eb1ebc","dib":"_f-dib-35c9bc","dn-ns":"_f-dn-ns-558298","flex":"_f-flex-52e1f3","flex-column":"_f-flex-column-d1b405","flex-wrap":"_f-flex-wrap-716d62","items-center":"_f-items-center-5d2e80","justify-between":"_f-justify-between-e95710","justify-around":"_f-justify-around-e7c00a","i":"_f-i-5a2bbe","normal":"_f-normal-02a886","h-auto":"_f-h-auto-8c42d6","link":"_f-link-78bef6","list":"_f-list-5791ac","mw-none":"_f-mw-none-045a7b","w-100":"_f-w-100-f998ac","w-auto":"_f-w-auto-27dca4","overflow-hidden":"_f-overflow-hidden-b9df88","static":"_f-static-446db1","relative":"_f-relative-b485a3","dark-gray":"_f-dark-gray-90e407","gray":"_f-gray-be895f","bg-near-white":"_f-bg-near-white-6ab488","bg-white":"_f-bg-white-c89eb6","pa0":"_f-pa0-9ca3e6","pa1":"_f-pa1-519320","pa3":"_f-pa3-4964ab","pl4":"_f-pl4-39625c","pr4":"_f-pr4-0c1a9b","pb4":"_f-pb4-6eb545","pt2":"_f-pt2-72ac9b","pv3":"_f-pv3-0e79a4","ph4":"_f-ph4-b310b3","ma0":"_f-ma0-e37fd8","collapse":"_f-collapse-b1c02b","no-underline":"_f-no-underline-56fb78","tc":"_f-tc-14bfc0","f6":"_f-f6-51956e","pointer":"_f-pointer-d6ec4c","f12":"_f-f12-de47af","pa-8":"_f-pa-8-d3825b"};

var s$d = {"reinsuranceBlock":"_f-reinsuranceBlock-d7c961","icon":"_f-icon-75b06e","a":"_f-a-e88364","iconPriceClub":"_f-iconPriceClub-529ba6","labels":"_f-labels-0f76bf","labelSmall":"_f-labelSmall-9df15f","labelLarge":"_f-labelLarge-25c9dd"};

// Define the exact translation keys as a map
var translationKeys = {
    0: {
        small: 'footer_rakutenGroup_reinsurance_links_state_small',
        large: 'footer_rakutenGroup_reinsurance_links_state_large',
    },
    1: {
        small: 'footer_rakutenGroup_reinsurance_links_clubRakuten_small',
        large: 'footer_rakutenGroup_reinsurance_links_clubRakuten_large',
    },
    2: {
        small: 'footer_rakutenGroup_reinsurance_links_warranty_small',
        large: 'footer_rakutenGroup_reinsurance_links_warranty_large',
    },
    3: {
        small: 'footer_rakutenGroup_reinsurance_links_help_small',
        large: 'footer_rakutenGroup_reinsurance_links_help_large',
    },
};
var LinkContent$3 = function (_a) {
    var _b, _c;
    var item = _a.item;
    var t$1 = useTranslate('footer').t;
    var itemKeys = translationKeys[item.id] || { small: '', large: '' };
    var small = ((_b = item === null || item === void 0 ? void 0 : item.labels) === null || _b === void 0 ? void 0 : _b.small) ? t$1(itemKeys.small) : '';
    var large = ((_c = item === null || item === void 0 ? void 0 : item.labels) === null || _c === void 0 ? void 0 : _c.large) ? t$1(itemKeys.large) : '';
    return (React.createElement(Fragment, null,
        React.createElement("img", { "data-qa": "icon-external", className: "".concat(s$d.icon, " ").concat(item.id === 1 && s$d.iconPriceClub), loading: "lazy", src: item.iconUrl, alt: large, width: item.width, height: item.height }),
        React.createElement("div", { className: "".concat(s$d.labels, " ").concat(t.flex, " ").concat(t['flex-column']) },
            React.createElement("span", { className: "".concat(t['dark-gray'], " ").concat(s$d.labelSmall) }, small),
            React.createElement("span", { className: "".concat(t.gray, " ").concat(s$d.labelLarge) }, large))));
};
var Reinsurance = function (_a) {
    var links = _a.links;
    var marketplace = useMarketplace().marketplace;
    return (React.createElement("div", { className: "".concat(t.flex, " ").concat(t.pa3, " ").concat(t['bg-white'], " ").concat(s$d.reinsuranceBlock) }, links
        .filter(function (item) { var _a; return ((_a = item.marketPlaceDisplay) === null || _a === void 0 ? void 0 : _a.includes(marketplace)) || item.marketPlaceDisplay === undefined; })
        .map(function (item) { return (React.createElement(LinkOrSpan, { key: item.id, href: item.link, className: "".concat(t.flex, " ").concat(t['no-underline'], " ").concat(s$d.a) },
        React.createElement(LinkContent$3, { item: item }))); })));
};

var s$c = {"socialIcons":"_f-socialIcons-48f3e7","socialIconsSpace":"_f-socialIconsSpace-4efb4a","iconSeparator":"_f-iconSeparator-3409bd"};

var LinkContent$2 = function (_a) {
    var item = _a.item;
    return (React.createElement(Fragment, null,
        React.createElement("img", { "data-qa": "icon-external", className: "".concat(s$c.socialIcons, " ").concat(t.db, " ").concat(t['overflow-hidden']), width: item.width, height: item.height, loading: "lazy", src: item.iconUrl }),
        React.createElement("span", { className: "".concat(t['sr-only']) }, item.label)));
};
var SocialLinks = function (_a) {
    var links = _a.links;
    return (React.createElement("div", { className: "".concat(s$c.socialIconsSpace, " ").concat(s$c.iconSeparator, " ").concat(t.flex, " ").concat(t['justify-around'], " ").concat(t['bg-white'], " ").concat(t.pv3, " ").concat(t.ph4) }, links.map(function (item) {
        return (React.createElement(LinkOrSpan, { key: item.id, href: item.link, rel: "noopener noreferrer nofollow", target: "_blank" },
            React.createElement(LinkContent$2, { item: item })));
    })));
};

var s$b = {"appsLinksContainer":"_f-appsLinksContainer-30e8b0","appsLinkPicContainer":"_f-appsLinkPicContainer-7f4e4e","osIsAndroid":"_f-osIsAndroid-4f1b17","isForIos":"_f-isForIos-63d782","osIsIos":"_f-osIsIos-0e53e1","isForAndroid":"_f-isForAndroid-dc56c8","appsLink":"_f-appsLink-bf7fbc","appsButton":"_f-appsButton-86fd64"};

var getClass = function (mobileDetect) {
    if (mobileDetect && mobileDetect.android) {
        return s$b.osIsAndroid;
    }
    if (mobileDetect && mobileDetect.ios) {
        return s$b.osIsIos;
    }
    return '';
};
var tolgeePrefixKey$3 = 'footer_apps';
var LinkContent$1 = function (_a) {
    var item = _a.item;
    return (React.createElement(Fragment, null,
        React.createElement("img", { "data-qa": "icon-external", loading: "lazy", className: "".concat(t.link, " ").concat(t['dark-gray'], " ").concat(s$b.appsButton), src: item.iconUrl, alt: item.label, width: item.width, height: item.height }),
        React.createElement("span", { className: "".concat(t['sr-only']) },
            React.createElement(T, { ns: "footer", keyName: "".concat(tolgeePrefixKey$3, "_").concat(item.tolgeeKey) }))));
};
// comment the following react component
var AppsLinks = function (props) {
    var link = props.link, links = props.links, mobileDetect = props.mobileDetect;
    var _a = useState(''), oSClass = _a[0], setOsClass = _a[1];
    // move the logic decision based on mobileDetect to the browser runtime, have the same server markup
    useEffect(function () {
        setOsClass(getClass(mobileDetect));
    });
    return (React.createElement("div", { className: " ".concat(s$b.appsLinksContainer, " ").concat(oSClass) },
        React.createElement(LinkOrSpan, { href: link, className: " ".concat(t.link, " ").concat(t['dark-gray'], " ").concat(s$b.appsLink, " ") },
            React.createElement(T, { ns: "footer", keyName: "".concat(tolgeePrefixKey$3, "_label") })),
        React.createElement("div", { className: "".concat(t.flex, " ").concat(s$b.appsLinkPicContainer) }, links.map(function (item) { return (React.createElement(LinkOrSpan, { key: "appsLinks-".concat(item.id), href: item.link, className: "".concat(item.os === 'android' ? s$b.isForAndroid : s$b.isForIos) },
            React.createElement(LinkContent$1, { item: item }))); }))));
};

var s$a = {"img":"_f-img-b69808"};

var LinkContent = function (_a) {
    var rakutenLogo = _a.rakutenLogo;
    return (React.createElement("img", { className: "".concat(t.db, " ").concat(t['mw-none'], " ").concat(s$a.img), src: rakutenLogo.img, loading: "lazy", 
        // @ts-expect-error can be null
        alt: /[^/]+$/.exec(rakutenLogo.img)[0] }));
};
var RakutenGroupLinksLogo = function (_a) {
    var rakutenLogo = _a.rakutenLogo;
    return (React.createElement(LinkOrSpan, { target: "_blank", rel: "noopener noreferrer", href: rakutenLogo.link },
        React.createElement(LinkContent, { rakutenLogo: rakutenLogo })));
};

var s$9 = {"anchor":"_f-anchor-dfbff4","companies":"_f-companies-86396e","list":"_f-list-114a53"};

var tolgeePrefixKey$2 = 'footer_rakutenGroup_companies';
var RakutenGroupLinksCompanies = function (_a) {
    var companies = _a.companies;
    return (React.createElement("ul", { className: "".concat(t.list, " ").concat(t.ma0, " ").concat(t.pa0, " ").concat(t.flex, " ").concat(t['justify-around'], " ").concat(t['w-100'], " ").concat(t.pr4, " ").concat(t.pl4, " ").concat(s$9.companies) }, companies.reduce(function (prev, company) {
        prev.push(
        // @ts-expect-error css
        React.createElement("li", { key: company.id, className: "".concat(s$9.list, " ").concat(s$9[company.name] ? s$9[company.name] : '') },
            React.createElement(LinkOrSpan, { target: "_blank", rel: "noopener noreferrer", href: company.link, className: "".concat(t.dib, " ").concat(t.normal, " ").concat(t['w-auto'], " ").concat(t['h-auto'], " ").concat(t['no-underline'], " ").concat(s$9.anchor) }, company.tolgeeKey ? React.createElement(T, { ns: "footer", keyName: "".concat(tolgeePrefixKey$2, "_").concat(company.tolgeeKey) }) : company.label)));
        return prev;
    }, [])));
};

function createVisitorUSACookie(urlRedirect) {
    if (typeof window !== 'undefined') {
        if (urlRedirect === 'https://www.rakuten.com') {
            document.cookie = 'visitor-usa=true; domain=.rakuten.com; path=/';
        }
    }
}
var getClassiqueHref = function () {
    var returnUrl = '/'; // for ssr, will update in browser matching the url visited
    if (typeof window !== 'undefined') {
        var urlObj = new URL(window.location.toString());
        urlObj.searchParams.set('force_version', 'classic');
        returnUrl = urlObj.toString();
    }
    return returnUrl;
};

var s$8 = {"container":"_f-container-c57e18","select":"_f-select-eb06d7"};

var tolgeePrefixKey$1 = 'footer_rakutenGroup_select';
var onClickForRedirectionUSA$1 = function onClickForRedirectionUSA(event) {
    event.preventDefault();
    if (event.target.value === 'https://www.rakuten.com') {
        createVisitorUSACookie(event.target.value);
    }
    return window.location.assign(event.target.value);
};
var RakutenGroupLinksSelect = function (_a) {
    var select = _a.select;
    return (React.createElement("div", { className: "".concat(t.relative, " ").concat(t.pointer, " ").concat(s$8.container) },
        React.createElement("select", { className: "".concat(t['bg-white'], " ").concat(t.pointer, " ").concat(s$8.select), onChange: onClickForRedirectionUSA$1 }, select.reduce(function (prev, country) {
            prev.push(React.createElement("option", { key: country.id, value: country.link },
                React.createElement(T, { ns: "footer", keyName: "".concat(tolgeePrefixKey$1, "_").concat(country.tolgeeKey) })));
            return prev;
        }, []))));
};

var s$7 = {"container":"_f-container-f8516a"};

var RakutenGroupLinks = function (_a) {
    var rakutenLogo = _a.rakutenLogo, companies = _a.companies, select = _a.select;
    return (React.createElement("div", { className: "".concat(t.flex, " ").concat(t['justify-between'], " ").concat(t['items-center'], " ").concat(t.pr4, " ").concat(t.pl4, " ").concat(t['bg-white'], " ").concat(s$7.container) },
        React.createElement(RakutenGroupLinksLogo, { rakutenLogo: rakutenLogo }),
        React.createElement(RakutenGroupLinksCompanies, { companies: companies }),
        React.createElement(RakutenGroupLinksSelect, { select: select })));
};

var s$6 = {"groupedLinksLabel":"_f-groupedLinksLabel-ee3511","linkItem":"_f-linkItem-98258d","icon":"_f-icon-17b47c","iconed":"_f-iconed-219ddf","linkIcon":"_f-linkIcon-ec5057","collapse":"_f-collapse-804631","pmCorpGroupList":"_f-pmCorpGroupList-75d05b","slideUp":"_f-slideUp-d257c2","slideDown":"_f-slideDown-8a1077"};

var noFollows = ['/publicite/'];
var tolgeePrefixKey = 'footer_corporate_groups';
var CorporateBlocks = /** @class */ (function (_super) {
    __extends(CorporateBlocks, _super);
    function CorporateBlocks(props) {
        var _this = _super.call(this, props) || this;
        _this.renderLink = function (item) {
            if (noFollows.includes(item.link) || item.noFollow) {
                return (React.createElement(LinkOrSpan, __assign({}, item, { href: item.link, className: "".concat(t.link, " ").concat(t['dark-gray']), rel: "nofollow" }),
                    React.createElement(T, { ns: "footer", keyName: "".concat(tolgeePrefixKey, "_").concat(item.tolgeeKey) })));
            }
            return (React.createElement(LinkOrSpan, __assign({}, item, { href: item.link, className: "".concat(t.link, " ").concat(t['dark-gray']) }),
                React.createElement(T, { ns: "footer", keyName: "".concat(tolgeePrefixKey, "_").concat(item.tolgeeKey) })));
        };
        var isOpen = props.groupedLinks.isOpen ? !props.groupedLinks.isOpen : true;
        _this.state = {
            closed: isOpen,
        };
        _this.onToggle = _this.onToggle.bind(_this);
        return _this;
    }
    CorporateBlocks.prototype.onToggle = function () {
        var closed = this.state.closed;
        this.setState({ closed: !closed });
    };
    CorporateBlocks.prototype.render = function () {
        var _this = this;
        var closed = this.state.closed;
        var groupedLinks = this.props.groupedLinks;
        var slideClass = closed ? s$6.slideUp : s$6.slideDown;
        var collapsibleClass = "".concat(s$6.collapse, " ").concat(t['helper_hide-AboveTablet']);
        var collapsibleIcon = closed ? (React.createElement("img", { src: '/visuels/0_TECH/shared-svg/plusIcon.svg', "data-qa": "icon-external", className: collapsibleClass, width: '16', height: '16', loading: "lazy" })) : (React.createElement("img", { src: '/visuels/0_TECH/shared-svg/minusIcon.svg', "data-qa": "icon-external", className: collapsibleClass, width: '16', height: '16', loading: "lazy" }));
        return (React.createElement("li", { className: "".concat(t.pa0, " ").concat(t.list, " ").concat(s$6.pmCorpGroupList), "data-qa": "footer-corporate-block", onClick: this.onToggle },
            React.createElement("div", { className: "".concat(t.pa0, " ").concat(t['dark-gray'], " ").concat(s$6.groupedLinksLabel) },
                groupedLinks.iconUrl && (React.createElement("img", { "data-qa": "icon-external", className: "".concat(s$6.linkIcon, " ").concat(t['helper_hide-AboveTablet']), src: groupedLinks.iconUrl, width: groupedLinks.width, height: groupedLinks.height, loading: "lazy" })),
                React.createElement(T, { ns: "footer", keyName: "".concat(tolgeePrefixKey, "_").concat(groupedLinks.tolgeeKey, "_label") }),
                collapsibleIcon),
            React.createElement("ul", { className: "".concat(t.list, " ").concat(t.pa0, " ").concat(slideClass) }, groupedLinks.links
                .filter(function (item) { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.marketPlaceDisplay) === null || _a === void 0 ? void 0 : _a.includes(_this.props.marketplace)) || item.marketPlaceDisplay === undefined; })
                .map(function (item) { return (React.createElement("li", { key: "corporateBlocks-".concat(groupedLinks.iconUrl, "-").concat(item.id), "data-qa": "footer-corporate-link", className: "".concat(t['bg-near-white'], " ").concat(s$6.linkItem, " ").concat(item.iconUrl ? s$6.iconed : '', " ").concat(item.hideOnDesktop ? t['helper_hide-AboveTablet'] : '') },
                item.iconUrl && (React.createElement("img", { "data-qa": "icon-external", className: "".concat(s$6.icon, " ").concat(t['helper_hide-AboveTablet']), src: item.iconUrl, width: item.width, height: item.height, loading: "lazy" })),
                _this.renderLink(item))); }))));
    };
    return CorporateBlocks;
}(Component));

var s$5 = {"groupedLinksLabel":"_f-groupedLinksLabel-825f99","linkItem":"_f-linkItem-8d35bc","pmCorpLinks":"_f-pmCorpLinks-e748d4"};

var PriceministerCorporate = function (_a) {
    var groups = _a.groups, marketplace = _a.marketplace;
    return (React.createElement("ul", { className: "".concat(t.pa0, " ").concat(t.ma0, " ").concat(t['bg-near-white'], " ").concat(s$5.pmCorpLinks) }, groups.map(function (groupedLinks) { return (React.createElement(CorporateBlocks, { groupedLinks: groupedLinks, marketplace: marketplace, key: "priceministerCorporate-".concat(groupedLinks.iconUrl) })); })));
};

var s$4 = {"paymentMethodsSpace":"_f-paymentMethodsSpace-3802f6"};

/* eslint-disable react/no-array-index-key */
var PaymentMethods = function (_a) {
    var icons = _a.icons;
    return (React.createElement("div", { className: "".concat(s$4.paymentMethodsSpace, " ").concat(t.pv3, " ").concat(t.ph4, " ").concat(t.flex, " ").concat(t['justify-around'], " ").concat(t['bg-white']) }, icons.map(function (item, id) { return (React.createElement("div", { className: "".concat(t.pt2), key: "PaymentMethods_".concat(id) },
        React.createElement("img", { "data-qa": "icon-external", className: "".concat(t.db, " ").concat(t['overflow-hidden']), src: item.iconUrl, alt: item.label, width: item.width, height: item.height, loading: "lazy" }),
        React.createElement("span", { className: "".concat(t['sr-only']) }, item.label))); })));
};

var s$3 = {"pmCopyright":"_f-pmCopyright-df8ed1","rk_Pm_Copyright":"_f-rk_Pm_Copyright-8241ce"};

var s$2 = {"anchor":"_f-anchor-e97f0b","links":"_f-links-aa9259","companies":"_f-companies-af6cba","list":"_f-list-ff364f"};

var RakutenSdtLinksInline = function (_a) {
    var _b = _a.links, links = _b === void 0 ? [] : _b;
    return (React.createElement("ul", { className: "".concat(t.list, " ").concat(t.ma0, " ").concat(t.pa0, " ").concat(t.flex, " ").concat(t['justify-around'], " ").concat(t['w-100'], " ").concat(t.pr4, " ").concat(t.pl4, " ").concat(t.pb4, " ").concat(s$2.companies) }, links.reduce(function (prev, link) {
        prev.push(React.createElement("li", { key: link.id, className: "".concat(t.flex, " ").concat(t.pa1, " ").concat(s$2.links, " ").concat(s$2.list) },
            React.createElement("a", { target: "_self", rel: "noopener noreferrer", href: link.link, className: "".concat(t.dib, " ").concat(t.normal, " ").concat(t['w-auto'], " ").concat(t['h-auto'], " ").concat(s$2.anchor) }, link.label)));
        return prev;
    }, [])));
};

var s$1 = {"container":"_f-container-c4e246"};

var RakutenSdtLinks = function (_a) {
    var links = _a.links;
    return (React.createElement("div", { className: "".concat(t.flex, " ").concat(t['justify-between'], " ").concat(t['items-center'], " ").concat(t.pr4, " ").concat(t.pl4, " ").concat(t['bg-white'], " ").concat(s$1.container) },
        React.createElement(RakutenSdtLinksInline, { links: links })));
};

var footerStatic = {
    apps: {
        label: "Avec l'appli Rakuten, bénéficiez de 5% remboursés en Rakuten Points sur tous vos achats !",
        link: '/event/club-rakuten#xtatc=PUB-[PMC][HomePage][x7App][]',
        links: [
            {
                id: 0,
                link: 'https://app.appsflyer.com/id579373363?pid=PriceMinister&c=Page_EVT_2015',
                label: 'Application Appstore',
                iconUrl: '/visuels/0_TECH/shared-svg/appStoreIcon.svg',
                width: '135',
                height: '40',
                os: 'apple',
                tolgeeKey: 'appStore',
            },
            {
                id: 1,
                link: 'https://app.appsflyer.com/com.priceminister.buyerapp?pid=PriceMinister&c=Page_EVT_2015',
                label: 'Application Android',
                iconUrl: '/visuels/0_TECH/shared-svg/playStoreIcon.svg',
                width: '135',
                height: '40',
                os: 'android',
                tolgeeKey: 'playStore',
            },
        ],
    },
    corporate: {
        groups: [
            {
                label: 'Liens utiles',
                iconUrl: '/visuels/0_TECH/shared-svg/starIcon.svg',
                width: '24',
                height: '24',
                isOpen: true,
                tolgeeKey: 'usefulLinks',
                links: [
                    {
                        id: 0,
                        link: '/connect?action=login&c=80',
                        label: 'Mon compte',
                        iconUrl: '/visuels/0_TECH/shared-svg/profileIcon.svg',
                        width: '24',
                        height: '24',
                        dataQA: 'footer-account',
                        tolgeeKey: 'account',
                    },
                    {
                        id: 1,
                        link: '/cart',
                        label: 'Mon panier',
                        iconUrl: '/visuels/0_TECH/shared-svg/cartIcon.svg',
                        width: '24',
                        height: '24',
                        dataQA: 'footer-cart',
                        tolgeeKey: 'cart',
                    },
                    {
                        id: 2,
                        link: 'https://help.fr.shopping.rakuten.net/hc/fr/articles/16298345113362-Je-souhaite-payer-en-plusieurs-fois-sur-la-plateforme-Rakuten-',
                        label: 'Paiement en plusieurs fois',
                        iconUrl: '/visuels/0_TECH/shared-svg/creditCardIcon.svg',
                        width: '24',
                        height: '24',
                        dataQA: 'footer-payment',
                        tolgeeKey: 'payment',
                    },
                    {
                        id: 3,
                        link: '/v/vendre',
                        label: 'Vendre',
                        iconUrl: '/visuels/0_TECH/shared-svg/sellIcon.svg',
                        width: '24',
                        height: '24',
                        dataQA: 'footer-sell',
                        tolgeeKey: 'sell',
                        marketPlaceDisplay: ['fr'],
                    },
                    {
                        id: 4,
                        link: '/connect?action=login',
                        label: 'Suivre ma commande',
                        iconUrl: '/visuels/0_TECH/shared-svg/orderTrackingIcon.svg',
                        width: '24',
                        height: '24',
                        dataQA: 'footer-tracking',
                        tolgeeKey: 'tracking',
                    },
                    {
                        id: 5,
                        link: '/connect?action=login',
                        label: 'Mon Club R',
                        iconUrl: '/visuels/0_TECH/shared-svg/cardIcon.svg',
                        width: '24',
                        height: '24',
                        dataQA: 'footer-clubR',
                        tolgeeKey: 'clubR',
                        marketPlaceDisplay: ['fr'],
                    },
                ],
            },
            {
                label: 'Aide',
                iconUrl: '/visuels/0_TECH/shared-svg/helpIcon.svg',
                width: '24',
                height: '24',
                isOpen: false,
                tolgeeKey: 'help',
                links: [
                    {
                        id: 0,
                        link: '/newhelp/',
                        label: "Besoin d'aide ?",
                        dataQA: 'footer-help',
                        tolgeeKey: 'needHelp',
                    },
                    {
                        id: 1,
                        link: '/seller/sell-register-pro',
                        label: 'Ouvrir un e-shop en tant que commerçant',
                        dataQA: 'footer-openShop',
                        tolgeeKey: 'openShop',
                    },
                    {
                        id: 2,
                        link: 'https://help.fr.shopping.rakuten.net/hc/fr/articles/10324490666002-A-quoi-correspondent-les-frais-prélevés-lors-de-mon-achat',
                        label: 'Frais de protection acheteurs',
                        dataQA: 'footer-protection',
                        tolgeeKey: 'protection',
                        marketPlaceDisplay: ['fr'],
                    },
                    {
                        id: 3,
                        link: '/newhelp/signalements/',
                        label: 'Signaler un contenu illicite',
                        tolgeeKey: 'report',
                    },
                    {
                        id: 4,
                        link: '/plan-de-site/sitemap-nav',
                        label: 'Plan du site',
                        tolgeeKey: 'siteMap',
                    },
                    {
                        id: 5,
                        link: 'https://global.fr.shopping.rakuten.com/actualite/',
                        label: 'Le blog',
                        tolgeeKey: 'blog',
                    },
                ],
            },
            {
                label: 'Rakuten',
                iconUrl: '/visuels/0_TECH/shared-svg/infoIcon.svg',
                width: '24',
                height: '24',
                isOpen: false,
                tolgeeKey: 'rakuten',
                links: [
                    {
                        id: 0,
                        link: 'https://global.fr.shopping.rakuten.com/nos-offres/',
                        label: 'Carrières',
                        tolgeeKey: 'careers',
                    },
                    {
                        id: 1,
                        link: '/newhelp/conditions-generales/',
                        label: 'Conditions générales',
                        tolgeeKey: 'terms',
                    },
                    {
                        id: 2,
                        link: 'https://fr.shopping.rakuten.com/event/mentions-legales',
                        label: '*Conditions des offres',
                        tolgeeKey: 'offersConditions',
                    },
                    {
                        id: 3,
                        link: '/newhelp/vie-privee-et-cookies/',
                        label: 'Politique Vie privée',
                        tolgeeKey: 'privacy',
                    },
                    {
                        id: 4,
                        link: '#',
                        action: 'openDidomi',
                        label: 'Gestion des cookies',
                        tolgeeKey: 'cookieManagement',
                    },
                    {
                        id: 5,
                        link: '/evt/affiliation-PM',
                        label: 'Affiliation',
                        tolgeeKey: 'affiliation',
                        marketPlaceDisplay: ['fr'],
                    },
                    {
                        id: 6,
                        link: '/publicite/',
                        label: 'Devenez annonceur',
                        tolgeeKey: 'advertiser',
                        marketPlaceDisplay: ['fr'],
                    },
                    {
                        id: 7,
                        link: 'https://global.fr.shopping.rakuten.com/rakuten-monde/',
                        label: 'A propos de Rakuten',
                        tolgeeKey: 'about',
                    },
                    {
                        id: 8,
                        link: '/newhelp/fonctionnement/',
                        label: 'Fonctionnement du service',
                        tolgeeKey: 'serviceOperation',
                    },
                    {
                        id: 9,
                        link: '/event/assurance',
                        label: 'Assurances',
                        tolgeeKey: 'insurance',
                        marketPlaceDisplay: ['fr'],
                    },
                ],
            },
        ],
    },
    rakutenGroup: {
        rakutenLogo: {
            link: 'https://global.rakuten.com/',
            img: 'https://fr.shopping.rakuten.com/visuels/0_TECH/shared-svg/RakutenLogos.svg',
        },
        companies: [
            {
                id: 0,
                link: 'https://rd.rakuten.co.jp/s2/?R2=https%3A%2F%2Fwww.kobo.com%2F&D2=638.0.254426.0.32267295&C3=0b89bca361af97fbd21151cec125e851fc43e74f',
                name: 'kobo',
                label: 'Rakuten Kobo',
            },
            {
                id: 1,
                link: 'https://rd.rakuten.co.jp/s2/?R2=https%3A%2F%2Ffr.rakuten.tv%2F&D2=638.0.254426.0.32267300&C3=7569a51ff88b2c7a761d90b3517c01a362070fdb',
                name: 'tv',
                label: 'Rakuten TV',
            },
            {
                id: 2,
                link: 'https://rd.rakuten.co.jp/s2/?R2=https%3A%2F%2Fwww.viber.com%2Ffr%2F&D2=638.0.254426.0.32267296&C3=5785bb59de25ef8f0d5c143aea26b265b019aee4',
                name: 'viber',
                label: 'Rakuten Viber',
            },
            {
                id: 3,
                link: 'https://rd.rakuten.co.jp/s2/?R2=https%3A%2F%2Fwww.viki.com%2F&D2=638.0.254426.0.32267294&C3=8c4f956fd025fffc9af6ee87c5ee18029e98a06d',
                name: 'viki',
                label: 'Rakuten Viki',
            },
            {
                id: 4,
                link: 'https://rd.rakuten.co.jp/s2/?R2=https%3A%2F%2Fglobal.rakuten.com%2Fcorp%2Fabout%2Fcompany%2F&D2=638.0.254426.0.32267305&C3=a39d9a4bd3a6fae9223f079e192d7c8874091763',
                name: 'aboutCompany',
                label: 'Plus de services',
                tolgeeKey: 'moreService',
            },
            {
                id: 5,
                link: 'https://rd.rakuten.co.jp/s2/?R2=https%3A%2F%2Fglobal.rakuten.com%2Fcorp%2Fabout%2Ffr%2F&D2=638.0.254426.0.32267304&C3=c00ff816abc6bd9961d86b36399aae96331a93ca',
                name: 'aboutFr',
                label: 'À propos de Rakuten',
                tolgeeKey: 'about',
            },
        ],
        select: [
            {
                id: 0,
                link: 'https://fr.shopping.rakuten.com',
                label: 'France',
                tolgeeKey: 'france',
            },
            {
                id: 1,
                link: 'https://www.rakuten.de',
                label: 'Allemagne',
                tolgeeKey: 'germany',
            },
            {
                id: 2,
                link: 'https://www.rakuten.com.br',
                label: 'Brésil',
                tolgeeKey: 'brazil',
            },
            {
                id: 3,
                link: 'https://www.rakuten.com',
                label: 'Etats-Unis',
                tolgeeKey: 'usa',
            },
            {
                id: 4,
                link: 'https://www.rakuten.co.jp',
                label: 'Japon',
                tolgeeKey: 'japan',
            },
            {
                id: 5,
                link: 'https://www.rakuten.com.tw',
                label: 'Taïwan',
                tolgeeKey: 'taiwan',
            },
        ],
    },
    reinsurance: {
        links: [
            {
                id: 0,
                link: '/newhelp/a-quoi-correspondent-les-etats-des-articles/',
                labels: {
                    small: 'Le choix',
                    large: 'Neuf et occasion',
                },
                iconUrl: '/visuels/0_TECH/shared-svg/bagIcon.svg',
                width: '43',
                height: '43',
            },
            {
                id: 1,
                link: '/event/club-rakuten',
                labels: {
                    small: 'Minimum',
                    large: '5% remboursés',
                },
                iconUrl: '/visuels/0_TECH/shared-svg/cardIcon.svg',
                width: '80',
                height: '43',
                marketPlaceDisplay: ['fr'],
            },
            {
                id: 2,
                link: 'https://help.fr.shopping.rakuten.net/hc/fr/articles/10324490666002-A-quoi-correspondent-les-frais-de-protection-acheteur-pr%C3%A9lev%C3%A9s-lors-de-mon-achat',
                labels: {
                    small: 'La sécurité',
                    large: 'Satisfait ou remboursé',
                },
                iconUrl: '/visuels/0_TECH/shared-svg/shieldIcon.svg',
                width: '43',
                height: '43',
                marketPlaceDisplay: ['fr'],
            },
            {
                id: 3,
                link: '/newhelp/',
                labels: {
                    small: 'Le service clients',
                    large: 'À votre écoute',
                },
                iconUrl: '/visuels/0_TECH/shared-svg/customerCareIcon.svg',
                width: '43',
                height: '43',
            },
        ],
    },
    social: {
        links: [
            {
                id: 0,
                link: 'https://www.linkedin.com/company/rakutenfrance',
                label: 'Linkedin',
                iconUrl: '/visuels/0_TECH/shared-svg/linkedinIcon.svg',
                width: '34',
                height: '34',
            },
            {
                id: 1,
                link: 'https://www.facebook.com/RakutenFrance',
                label: 'Facebook',
                iconUrl: '/visuels/0_TECH/shared-svg/facebookIcon.svg',
                width: '34',
                height: '34',
            },
            {
                id: 2,
                link: 'https://twitter.com/RakutenFrance',
                label: 'Twitter',
                iconUrl: '/visuels/0_TECH/shared-svg/twitterIcon.svg',
                width: '34',
                height: '34',
            },
            {
                id: 3,
                link: 'https://www.instagram.com/rakutenfrance',
                label: 'Instagram',
                iconUrl: '/visuels/0_TECH/shared-svg/instagramIcon.svg',
                width: '34',
                height: '34',
            },
            {
                id: 4,
                link: 'https://www.youtube.com/c/rakutenfrance',
                label: 'Youtube',
                iconUrl: '/visuels/0_TECH/shared-svg/youtubeIcon.svg',
                width: '34',
                height: '34',
            },
            {
                id: 5,
                link: 'https://www.pinterest.com/rakutenfrance',
                label: 'Pinterest',
                iconUrl: '/visuels/0_TECH/shared-svg/pinterestIcon.svg',
                width: '34',
                height: '34',
            },
            {
                id: 6,
                link: 'https://www.tiktok.com/@rakutenfrance',
                label: 'Tiktok',
                iconUrl: '/visuels/0_TECH/shared-svg/tiktokIcon.svg',
                width: '34',
                height: '34',
            },
        ],
    },
    payment: {
        icons: [
            {
                id: 0,
                label: 'visa',
                iconUrl: '/visuels/0_TECH/shared-svg/visaIcon.svg',
                width: '45',
                height: '25',
            },
            {
                id: 1,
                label: 'mastercard',
                iconUrl: '/visuels/0_TECH/shared-svg/mastercardIcon.svg',
                width: '34',
                height: '34',
            },
            {
                id: 2,
                label: 'klarna',
                iconUrl: '/visuels/0_TECH/shared-svg/klarna.svg',
                width: '54',
                height: '30',
            },
            {
                id: 3,
                label: 'paypal',
                iconUrl: '/visuels/0_TECH/shared-svg/paypalIcon.svg',
                width: '60',
                height: '34',
            },
            {
                id: 4,
                label: 'floa',
                iconUrl: '/visuels/0_TECH/shared-svg/floaLogo.svg',
                width: '73',
                height: '25',
            },
            {
                id: 5,
                label: 'americanexpress',
                iconUrl: '/visuels/0_TECH/shared-svg/americanExpress.svg',
                width: '34',
                height: '34',
            },
        ],
    },
};

var _a, _b;
var config = configService.get();
var NAME = 'footer';
var DEFAULT_STATE = {
    visible: true,
    featureFlipping: {
        sellHomeRedirection: {
            isActive: (_a = config.featureFlipping.sellHomeRedirectionIsActive) !== null && _a !== void 0 ? _a : false,
        },
        onboardingPro: {
            isActive: (_b = config.featureFlipping.merchantOnboardingIsActive) !== null && _b !== void 0 ? _b : false
        }
    },
};
var SELL_HOME = {
    link: '/seller/sell-form',
};
var NEW_ONBOARDING_PRO = {
    link: '/onboarding-pro/user-information',
};

var constants = /*#__PURE__*/Object.freeze({
  __proto__: null,
  NAME: NAME,
  DEFAULT_STATE: DEFAULT_STATE,
  SELL_HOME: SELL_HOME,
  NEW_ONBOARDING_PRO: NEW_ONBOARDING_PRO
});

var onClickForRedirectionUSA = function () {
    createVisitorUSACookie('https://www.rakuten.com');
    window.location.assign('https://www.rakuten.com');
};
var updateCorporateGroups = function (corporate, groupeIndex, values) {
    var _a;
    if (Array.isArray(corporate) && corporate.length > 0) {
        var groups = corporate[groupeIndex];
        if (groups) {
            groups = __assign(__assign({}, groups), { links: (_a = groups.links) === null || _a === void 0 ? void 0 : _a.map(function (groupLink) {
                    if (groupLink.id === (values === null || values === void 0 ? void 0 : values.id)) {
                        return __assign(__assign({}, groupLink), values);
                    }
                    return groupLink;
                }) });
            corporate[groupeIndex] = groups;
        }
    }
    return corporate;
};
var RenderFooter = function (props) {
    var _a;
    var graphQlData = props.graphQlData, footer = props.footer;
    var featureFlipping = (footer || {}).featureFlipping;
    var marketplace = useMarketplace().marketplace;
    var copyright = "\u00A9 Rakuten France 2000 - ".concat(new Date().getFullYear());
    var defaultCorporateGroupLinks = function () {
        var defaultLinks = __spreadArray([], footerStatic.corporate.groups, true);
        if (featureFlipping === null || featureFlipping === void 0 ? void 0 : featureFlipping.sellHomeRedirection.isActive) {
            defaultLinks = updateCorporateGroups(__spreadArray([], defaultLinks, true), 0, { id: 3, link: SELL_HOME.link });
        }
        if (featureFlipping === null || featureFlipping === void 0 ? void 0 : featureFlipping.onboardingPro.isActive) {
            defaultLinks = updateCorporateGroups(__spreadArray([], defaultLinks, true), 1, { id: 1, link: NEW_ONBOARDING_PRO.link });
        }
        return defaultLinks;
    };
    var _b = useState([]), logoutLink = _b[0], setLogoutLink = _b[1];
    var _c = useState([]), siteClassicLink = _c[0], setSiteClassicLink = _c[1];
    var initalPriceministerCorporateGroup = useState(defaultCorporateGroupLinks)[0];
    var _d = useState(initalPriceministerCorporateGroup), priceministerCorporateGroup = _d[0], setPriceministerCorporateGroup = _d[1];
    useEffect(function () {
        var _a;
        if (graphQlData === null || graphQlData === void 0 ? void 0 : graphQlData.profile) {
            var logoutUrl = '/connect?action=logout';
            if ((_a = props.md.wsParams) === null || _a === void 0 ? void 0 : _a.isMobile) {
                logoutUrl = '/security_logout_front';
            }
            setLogoutLink([
                {
                    id: 6,
                    link: logoutUrl,
                    label: 'Déconnexion',
                    iconUrl: '/visuels/0_TECH/shared-svg/logoutIcon.svg',
                    width: '24',
                    height: '24',
                    dataQA: 'footer-logout',
                    tolgeeKey: 'logout',
                },
            ]);
        }
    }, [props.md, graphQlData]);
    useEffect(function () {
        if (props.showClassicPageLink) {
            setSiteClassicLink([
                {
                    id: 7,
                    link: getClassiqueHref(),
                    label: 'Accéder au site classique',
                    iconUrl: '/visuels/0_TECH/shared-svg/computerIcon.svg',
                    width: '24',
                    height: '24',
                    hideOnDesktop: true,
                    noFollow: true,
                    dataQA: 'footer-classicLink',
                    tolgeeKey: 'classicSite',
                },
            ]);
        }
    }, [props.showClassicPageLink]);
    useEffect(function () {
        setPriceministerCorporateGroup([
            __assign(__assign({}, initalPriceministerCorporateGroup[0]), { links: __spreadArray(__spreadArray(__spreadArray([], initalPriceministerCorporateGroup[0].links, true), logoutLink, true), siteClassicLink, true) }),
            initalPriceministerCorporateGroup[1],
            initalPriceministerCorporateGroup[2],
        ]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [logoutLink, siteClassicLink]);
    var links = [];
    if ((_a = graphQlData === null || graphQlData === void 0 ? void 0 : graphQlData.seoLinks) === null || _a === void 0 ? void 0 : _a.links) {
        // eslint-disable-next-line prefer-destructuring
        links = graphQlData.seoLinks.links;
    }
    var childContext = {
        displayLink: false,
    };
    return (React.createElement("footer", { className: "".concat(t['bg-near-white'], " footer"), "data-qa": "footer-root" },
        React.createElement(LinkOrSpanContext.Provider, { value: childContext },
            React.createElement(Reinsurance, { links: footerStatic.reinsurance.links }),
            React.createElement(PriceministerCorporate, { groups: priceministerCorporateGroup, marketplace: marketplace }),
            React.createElement("div", { className: "".concat(t.flex, " ").concat(t['flex-wrap'], " ").concat(t.pv3, " ").concat(t['bg-white']) },
                React.createElement(SocialLinks, { links: footerStatic.social.links }),
                React.createElement(PaymentMethods, { icons: footerStatic.payment.icons })),
            React.createElement(AppsLinks, { links: footerStatic.apps.links, link: footerStatic.apps.link, label: footerStatic.apps.label, mobileDetect: props.md }),
            React.createElement(RakutenGroupLinks, { companies: footerStatic.rakutenGroup.companies, select: footerStatic.rakutenGroup.select, rakutenLogo: footerStatic.rakutenGroup.rakutenLogo }),
            React.createElement("div", { className: "".concat(t['dn-ns']) },
                React.createElement(LinkOrSpan, { className: "".concat(t['pa-8'], " ").concat(t.flex, " ").concat(t['justify-around'], " ").concat(t['w-100'], " ").concat(t['bg-white'], " ").concat(t.link, " ").concat(t.gray, " ").concat(t.f6), rel: "nofollow", href: "#", onClick: function () { return onClickForRedirectionUSA(); } }, "Rakuten.com")),
            React.createElement("div", { className: "".concat(t['bg-white'], " ").concat(s$3.rk_Pm_Copyright) },
                React.createElement("p", { className: "".concat(t['pa-8'], " ").concat(t.tc, " ").concat(t['bg-white'], " ").concat(t['dark-gray'], " ").concat(s$3.pmCopyright, " ").concat(t.f12) }, copyright)),
            React.createElement(RakutenSdtLinks, { links: links }))));
};
var Footer = /** @class */ (function (_super) {
    __extends(Footer, _super);
    function Footer(props) {
        return _super.call(this, props) || this;
    }
    Footer.prototype.render = function () {
        var _a, _b;
        // retro compatible footer between next.js
        // not using react-router and connected-react-router vs the other apps
        if (!this.props.router) {
            // next.js case, hypernova case or other -fo ===> No react router / connected react router available
            if (this.props.toggleFiltersAndUniverses !== null) {
                // next.js only
                if (this.props.toggleFiltersAndUniverses === false) {
                    return React.createElement(RenderFooter, __assign({}, this.props));
                }
            }
            else {
                // hypernova case or other -fo => we render the footer
                return React.createElement(RenderFooter, __assign({}, this.props));
            }
        }
        if (this.props.router) {
            // -fo case with connected-react-router
            if (!((_b = (_a = this.props.router.location) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.toggleFiltersAndUniverses)) {
                return React.createElement(RenderFooter, __assign({}, this.props));
            }
        }
        return null;
    };
    Footer.defaultProps = {
        showClassicPageLink: false,
        md: {
            userAgent: null,
        },
        toggleFiltersAndUniverses: false,
    };
    Footer.initialFragments = {
        seoLinks: gql(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n      fragment FooterSeoLinks on SeoLinks {\n        links {\n          id\n          link\n          label\n        }\n      }\n    "], ["\n      fragment FooterSeoLinks on SeoLinks {\n        links {\n          id\n          link\n          label\n        }\n      }\n    "]))),
    };
    Footer.SSRFragment = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    fragment FooterSSRFragment on Query {\n      seoLinks {\n        links {\n          id\n          link\n          label\n        }\n      }\n    }\n  "], ["\n    fragment FooterSSRFragment on Query {\n      seoLinks {\n        links {\n          id\n          link\n          label\n        }\n      }\n    }\n  "])));
    Footer.PersonalizeFragment = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    fragment FooterpersonalizeFragment on Query {\n      profile {\n        firstNameOrPseudo\n      }\n    }\n  "], ["\n    fragment FooterpersonalizeFragment on Query {\n      profile {\n        firstNameOrPseudo\n      }\n    }\n  "])));
    Footer.personalizedFragments = {
        profile: gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      fragment FooterProfile on Profile {\n        firstNameOrPseudo\n      }\n    "], ["\n      fragment FooterProfile on Profile {\n        firstNameOrPseudo\n      }\n    "]))),
    };
    return Footer;
}(React.Component));
var templateObject_1$1, templateObject_2, templateObject_3, templateObject_4;

var footer_apps_appStore = "Application Appstore";
var footer_apps_label = "Avec l'appli Rakuten, bénéficiez de 5% remboursés en Rakuten Points sur tous vos achats !";
var footer_apps_playStore = "Application Android";
var footer_corporare_groups_logout = "Déconnexion";
var footer_corporate_groups_about = "A propos de Rakuten";
var footer_corporate_groups_account = "Mon compte";
var footer_corporate_groups_advertiser = "Devenez annonceur";
var footer_corporate_groups_affiliation = "Affiliation";
var footer_corporate_groups_blog = "Le blog";
var footer_corporate_groups_careers = "Carrières";
var footer_corporate_groups_cart = "Mon panier";
var footer_corporate_groups_classicSite = "Accéder au site classique";
var footer_corporate_groups_clubR = "Mon Club R";
var footer_corporate_groups_cookieManagement = "Gestion des cookies";
var footer_corporate_groups_help_label = "Aide";
var footer_corporate_groups_insurance = "Assurances";
var footer_corporate_groups_logout = "Déconnexion";
var footer_corporate_groups_needHelp = "Besoin d'aide ?";
var footer_corporate_groups_offersConditions = "*Conditions des offres";
var footer_corporate_groups_openShop = "Ouvrir un e-shop en tant que commerçant";
var footer_corporate_groups_payment = "Paiement en plusieurs fois";
var footer_corporate_groups_privacy = "Politique Vie privée";
var footer_corporate_groups_protection = "Frais de protection acheteurs";
var footer_corporate_groups_rakuten_label = "Rakuten";
var footer_corporate_groups_report = "Signaler un contenu illicite";
var footer_corporate_groups_sell = "Vendre";
var footer_corporate_groups_serviceOperation = "Fonctionnement du service";
var footer_corporate_groups_siteMap = "Plan du site";
var footer_corporate_groups_terms = "Conditions générales";
var footer_corporate_groups_tracking = "Suivre ma commande";
var footer_corporate_groups_usefulLinks_label = "Liens utiles";
var footer_rakutenGroup_companies_about = "À propos de Rakuten";
var footer_rakutenGroup_companies_moreService = "Plus de services";
var footer_rakutenGroup_reinsurance_links_clubRakuten_large = "5% remboursés";
var footer_rakutenGroup_reinsurance_links_clubRakuten_small = "Minimum";
var footer_rakutenGroup_reinsurance_links_help_large = "À votre écoute";
var footer_rakutenGroup_reinsurance_links_help_small = "Le service clients";
var footer_rakutenGroup_reinsurance_links_state_large = "Neuf et occasion";
var footer_rakutenGroup_reinsurance_links_state_small = "Le choix";
var footer_rakutenGroup_reinsurance_links_warranty_large = "Satisfait ou remboursé";
var footer_rakutenGroup_reinsurance_links_warranty_small = "La sécurité";
var footer_rakutenGroup_select_brazil = "Brésil";
var footer_rakutenGroup_select_france = "France";
var footer_rakutenGroup_select_germany = "Allemagne";
var footer_rakutenGroup_select_japan = "Japon";
var footer_rakutenGroup_select_taiwan = "Taïwan";
var footer_rakutenGroup_select_usa = "États-Unis";
var frFR = {
	footer_apps_appStore: footer_apps_appStore,
	footer_apps_label: footer_apps_label,
	footer_apps_playStore: footer_apps_playStore,
	footer_corporare_groups_logout: footer_corporare_groups_logout,
	footer_corporate_groups_about: footer_corporate_groups_about,
	footer_corporate_groups_account: footer_corporate_groups_account,
	footer_corporate_groups_advertiser: footer_corporate_groups_advertiser,
	footer_corporate_groups_affiliation: footer_corporate_groups_affiliation,
	footer_corporate_groups_blog: footer_corporate_groups_blog,
	footer_corporate_groups_careers: footer_corporate_groups_careers,
	footer_corporate_groups_cart: footer_corporate_groups_cart,
	footer_corporate_groups_classicSite: footer_corporate_groups_classicSite,
	footer_corporate_groups_clubR: footer_corporate_groups_clubR,
	footer_corporate_groups_cookieManagement: footer_corporate_groups_cookieManagement,
	footer_corporate_groups_help_label: footer_corporate_groups_help_label,
	footer_corporate_groups_insurance: footer_corporate_groups_insurance,
	footer_corporate_groups_logout: footer_corporate_groups_logout,
	footer_corporate_groups_needHelp: footer_corporate_groups_needHelp,
	footer_corporate_groups_offersConditions: footer_corporate_groups_offersConditions,
	footer_corporate_groups_openShop: footer_corporate_groups_openShop,
	footer_corporate_groups_payment: footer_corporate_groups_payment,
	footer_corporate_groups_privacy: footer_corporate_groups_privacy,
	footer_corporate_groups_protection: footer_corporate_groups_protection,
	footer_corporate_groups_rakuten_label: footer_corporate_groups_rakuten_label,
	footer_corporate_groups_report: footer_corporate_groups_report,
	footer_corporate_groups_sell: footer_corporate_groups_sell,
	footer_corporate_groups_serviceOperation: footer_corporate_groups_serviceOperation,
	footer_corporate_groups_siteMap: footer_corporate_groups_siteMap,
	footer_corporate_groups_terms: footer_corporate_groups_terms,
	footer_corporate_groups_tracking: footer_corporate_groups_tracking,
	footer_corporate_groups_usefulLinks_label: footer_corporate_groups_usefulLinks_label,
	footer_rakutenGroup_companies_about: footer_rakutenGroup_companies_about,
	footer_rakutenGroup_companies_moreService: footer_rakutenGroup_companies_moreService,
	footer_rakutenGroup_reinsurance_links_clubRakuten_large: footer_rakutenGroup_reinsurance_links_clubRakuten_large,
	footer_rakutenGroup_reinsurance_links_clubRakuten_small: footer_rakutenGroup_reinsurance_links_clubRakuten_small,
	footer_rakutenGroup_reinsurance_links_help_large: footer_rakutenGroup_reinsurance_links_help_large,
	footer_rakutenGroup_reinsurance_links_help_small: footer_rakutenGroup_reinsurance_links_help_small,
	footer_rakutenGroup_reinsurance_links_state_large: footer_rakutenGroup_reinsurance_links_state_large,
	footer_rakutenGroup_reinsurance_links_state_small: footer_rakutenGroup_reinsurance_links_state_small,
	footer_rakutenGroup_reinsurance_links_warranty_large: footer_rakutenGroup_reinsurance_links_warranty_large,
	footer_rakutenGroup_reinsurance_links_warranty_small: footer_rakutenGroup_reinsurance_links_warranty_small,
	footer_rakutenGroup_select_brazil: footer_rakutenGroup_select_brazil,
	footer_rakutenGroup_select_france: footer_rakutenGroup_select_france,
	footer_rakutenGroup_select_germany: footer_rakutenGroup_select_germany,
	footer_rakutenGroup_select_japan: footer_rakutenGroup_select_japan,
	footer_rakutenGroup_select_taiwan: footer_rakutenGroup_select_taiwan,
	footer_rakutenGroup_select_usa: footer_rakutenGroup_select_usa
};

var staticData = {
    'fr-FR:footer': frFR,
    'es-ES:footer': function () { return import('./es-ES-9c5897b8.js'); },
    'it-IT:footer': function () { return import('./it-IT-0929cc52.js'); },
    'pt-PT:footer': function () { return import('./pt-PT-87f396b7.js'); },
};

var mapStateToProps = function (state, ownProps) {
    var _a, _b, _c, _d;
    var data = ((_a = state.footer) === null || _a === void 0 ? void 0 : _a.data) || (ownProps === null || ownProps === void 0 ? void 0 : ownProps.data);
    return {
        footer: state.footer,
        data: data,
        toggleFiltersAndUniverses: (_c = (_b = state === null || state === void 0 ? void 0 : state.navandsearch) === null || _b === void 0 ? void 0 : _b.result.mob.toggleFiltersAndUniverses) !== null && _c !== void 0 ? _c : null,
        // toggleFiltersAndUniverses: !state?.router ? state.navandsearch.result.mob.toggleFiltersAndUniverses : null,
        router: (_d = state === null || state === void 0 ? void 0 : state.router) !== null && _d !== void 0 ? _d : null,
    };
};
var SSRFallbackQuery = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query footerSSRFallback {\n    ...FooterSSRFragment\n  }\n  ", "\n"], ["\n  query footerSSRFallback {\n    ...FooterSSRFragment\n  }\n  ", "\n"])), Footer.SSRFragment);
var FooterWithGraphQl = function (props) {
    var _a, _b, _c;
    // let data: GraphQlData | undefined;
    var md = useBreakpoint().md;
    var _d = props.PERSONALIZED_QUERY, PERSONALIZED_QUERY = _d === void 0 ? SSRFallbackQuery : _d, _e = props.PERSONALIZED_QUERY_OPTION, PERSONALIZED_QUERY_OPTION = _e === void 0 ? { ssr: true, skip: false } : _e;
    PERSONALIZED_QUERY_OPTION.ssr = true;
    PERSONALIZED_QUERY_OPTION.skip = false;
    PERSONALIZED_QUERY_OPTION.returnPartialData = true; // prevent hydration error
    var queryResult = useQuery(PERSONALIZED_QUERY, PERSONALIZED_QUERY_OPTION);
    return (React.createElement(TolgeeProvider, { ns: ['footer'], apiKey: (_b = (_a = publicRuntimeConfig.tolgee) === null || _a === void 0 ? void 0 : _a.apiKey) === null || _b === void 0 ? void 0 : _b['next-common'], apiUrl: (_c = publicRuntimeConfig.tolgee) === null || _c === void 0 ? void 0 : _c.apiUrl, staticData: staticData },
        React.createElement(MarketplaceProvider, null,
            React.createElement(Footer, __assign({}, props, { md: md, graphQlData: queryResult.data })))));
};
var ConnectedFooter = connect(mapStateToProps)(FooterWithGraphQl);
var HideInWebviewFooter = HideInWebviewHoc(ConnectedFooter);
// @ts-expect-error missing props
var BreakpointWrappedFooter = function (props) { return (React.createElement(BreakpointProvider, null,
    React.createElement(HideInWebviewFooter, __assign({}, props)))); };
BreakpointWrappedFooter.personalizedFraments = Footer.personalizedFragments;
BreakpointWrappedFooter.initalFragments = Footer.initialFragments;
BreakpointWrappedFooter.SSRFragment = Footer.SSRFragment;
BreakpointWrappedFooter.PersonalizeFragment = Footer.PersonalizeFragment;
var FooterContainer = BreakpointWrappedFooter;
var templateObject_1;

var SHOW = 'footer/SHOW';
var HIDE = 'footer/HIDE';

function reducer(state, action) {
    if (state === void 0) { state = DEFAULT_STATE; }
    switch (action.type) {
        case SHOW:
            return __assign(__assign({}, state), { visible: true });
        case HIDE:
            return __assign(__assign({}, state), { visible: false });
        default:
            return state;
    }
}

var initalAction = function (watchContext) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var language, tolgee, staticDataSSR;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(typeof window === 'undefined')) return [3 /*break*/, 2];
                    language = getLanguageFromRequest(watchContext.req);
                    tolgee = getTolgee({
                        language: language,
                        ns: ['footer'],
                        staticData: staticData,
                    });
                    return [4 /*yield*/, tolgee.loadRequired({ language: language })];
                case 1:
                    staticDataSSR = _a.sent();
                    dispatch(tolgeeModule.actions.addTolggeStaticData(staticDataSSR));
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
};

var containers = { FooterContainer: FooterContainer };
var footerModule = { containers: containers, constants: constants, reducer: reducer, initalAction: initalAction };

var footerDefaultLinks = [
    {
        text: 'Besoin d’aide ?',
        href: 'https://fr.shopping.rakuten.com/newhelp/',
    },
    {
        text: 'FAQ / Contacts',
        href: 'https://fr.shopping.rakuten.com/newhelp/',
    },
    {
        text: 'Conditions générales',
        href: 'https://fr.shopping.rakuten.com/newhelp/conditions-generales/',
    },
    {
        text: 'Vie privée et cookies',
        href: 'https://fr.shopping.rakuten.com/newhelp/vie-privee-et-cookies/',
    },
];

var s = {"footerMinimalContainer":"_f-footerMinimalContainer-4499fb","hyperlinksContainer":"_f-hyperlinksContainer-438c35","hyperlinkWrapper":"_f-hyperlinkWrapper-130bad","hyperlink":"_f-hyperlink-1542a5","hyperlinkDash":"_f-hyperlinkDash-f56d82","footerDateContainer":"_f-footerDateContainer-5125fe","footerDate":"_f-footerDate-980356"};

var FooterMinimal = function (_a) {
    var _b = _a.links, links = _b === void 0 ? footerDefaultLinks : _b;
    return (React.createElement("div", { className: s.footerMinimalContainer, "data-qa": "footer-minimal" },
        React.createElement("div", { className: s.hyperlinksContainer }, links.map(function (_a, i) {
            var text = _a.text, href = _a.href;
            return (React.createElement("div", { className: s.hyperlinkWrapper, key: text },
                React.createElement(Hyperlink, { href: href, color: "gray800", fontSize: "1.2rem", extraClassName: s.hyperlink, openLinkInNewTab: true }, text),
                i < links.length - 1 && React.createElement("div", { className: s.hyperlinkDash }, " - ")));
        })),
        React.createElement("div", { className: s.footerDateContainer },
            React.createElement("p", { className: s.footerDate }, "\u00A9 RAKUTEN France SAS 2000-".concat(new Date().getFullYear())))));
};
var FooterMinimalWrapped = function (props) { return (React.createElement(BreakpointProvider, null,
    React.createElement(HideInWebview, null,
        React.createElement(FooterMinimal, __assign({}, props))))); };

export { FooterMinimalWrapped as FooterMinimal, footerModule as default };
